import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { useUserContext } from "../utils/hooks/UserContext";
import Button from "./Button";
import LoginComponent from "../Front/Pages/Login";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import NotificationDropdown from "./NotificationDropdown";
import MenuItemsT from "./ProfileDropdown";
import { toast } from "react-toastify";
import BetaVsModel from "./BetaVs";

const defaultNavigation = [
  { name: "Home", href: "/", current: false },
  { name: "About Us", href: "/about", current: false },
  { name: "Browse Coach", href: "/browse-coach/list-view", current: false },
  { name: "Activity Stream", href: "/activity-stream", current: false },
  { name: "Become a Coach", href: "/become-a-coach", current: false },
];

const userNavigation = [
  { name: "Browse Coach", href: "/browse-coach/list-view", current: false },
  { name: "Activity Stream", href: "/activity-stream", current: false },
  { name: "Become a Coach", href: "/become-a-coach", current: false },
];

const coachNavigation = [
  { name: "Activity Stream", href: "/activity-stream", current: false },
  { name: "Become a Coach", href: "/become-a-coach", current: false },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function TailwindNavbar() {
  const { user, handleLogout } = useUserContext();
  const [loginModalShow, setLoginModalShow] = useState(false);
  const [navigation, setNavigation] = useState([]);
  const [profileDropdown, setProfileDropdown] = useState(false);
  const { pathname } = useLocation();
  const [activeMenu, setActiveMenu] = useState(
    JSON.parse(localStorage.getItem("navigation")) || "/"
  );
  /*   const [modalOpen, setModalOpen] = useState(
    localStorage.getItem("websiteDisplay") === "true" ? false : true
  ); */
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  console.log("gdhfshfshh", pathname);

  useEffect(() => {
    console.log("User type:", user?.userType);

    if (user?.userType === "coach") {
      setNavigation(coachNavigation);
    } else if (user?.userType === "user") {
      setNavigation(userNavigation);
    } else {
      setNavigation(defaultNavigation);
    }
  }, [user]);

  const getImage = (image) => {
    if (image) {
      if (user?.userType === "user") {
        return `${process.env.REACT_APP_USER_PROFILE_FOLDER_PATH}${image}`;
      } else if (user?.userType === "coach") {
        return `${process.env.REACT_APP_COACH_PROFILE_FOLDER_PATH}${image}`;
      }
    } else {
      return "https://i.pinimg.com/1200x/2c/47/d5/2c47d5dd5b532f83bb55c4cd6f5bd1ef.jpg";
    }
  };
  useEffect(() => {
    localStorage.setItem("websiteDisplay", true);
  }, []);

  useEffect(() => {
    const matchedNav = defaultNavigation.find((item) => item.href === pathname);
    if (matchedNav) {
      localStorage.setItem("navigation", JSON.stringify(matchedNav.href));
      setActiveMenu(matchedNav.href);
    }
  }, [pathname]);
  /* 
  const onHide = () => {
    setModalOpen(false);
  }; */

  /* const openSite = (e) => {
    e.preventDefault();
    if (password === "Admin@123") {
      localStorage.setItem("websiteDisplay", "true");
      setModalOpen(false);
      if (localStorage.getItem("websiteDisplay") === "true") {
        // toast.success('Login successfully');
        // window.location.reload();

        navigate(0);
      } else {
        console.error('Unexpected localStorage value for "websiteDisplay"');
      }
    } else {
      toast.error("Incorrect password");
    }
  }; */

  return (
    <Disclosure
      as="nav"
      className="bg-[#FBF3E4] py-2 fixed top-0 w-full z-[9999]"
    >
      <div className="px-2 mx-auto max-w-[1400px] lg:px-6">
        <div className="relative flex items-center justify-between h-16">
          <div className="absolute inset-y-0 left-0 flex items-center lg:hidden">
            <DisclosureButton className="relative inline-flex items-center justify-center p-2 text-gray-400 rounded-md group hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
              <span className="absolute -inset-0.5" />
              <span className="sr-only">Open main menu</span>
              <Bars3Icon
                aria-hidden="true"
                className="block size-6 group-data-[open]:hidden"
              />
              <XMarkIcon
                aria-hidden="true"
                className="hidden size-6 group-data-[open]:block"
              />
            </DisclosureButton>
          </div>
          <div className="flex items-center justify-start flex-1 lg:items-stretch">
            <div className="flex items-center shrink-0">
              <Link to="/">
                <img
                  alt="Company Logo"
                  src="/logo_dark.png"
                  className="w-auto h-8 ms-10 lg:ms-0"
                  onClick={() => {
                    localStorage.setItem("navigation", JSON.stringify("/"));
                    setActiveMenu("/"); // ✅ FIXED: This line ensures active menu updates
                  }}
                />
              </Link>
            </div>
          </div>
          <div className="hidden lg:ml-6 lg:block">
            <div className="flex space-x-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={classNames(
                    activeMenu === item.href
                      ? "bg-transparent border-b-2 border-[#00504E] text-[#00504E] font-bold rounded-xl scale-[1.02]"
                      : "text-gray-600 hover:text-[#00504E] hover:scale-[1.02]",
                    "rounded-xl font-medium hover:scale-110 hover:text-[#00504E] px-4 py-2 text-sm transition-all duration-200 ease-in-out transform"
                  )}
                  onClick={() => {
                    setActiveMenu(item.href);
                    localStorage.setItem(
                      "navigation",
                      JSON.stringify(item.href)
                    );
                  }}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="absolute inset-y-0 right-0 flex items-center pr-2 lg:static lg:inset-auto lg:ml-6 lg:pr-0">
            {user ? (
              <>
                <NotificationDropdown />
                <Menu as="div" className="relative ml-3">
                  <div>
                    <MenuButton
                      onClick={() => setProfileDropdown(!profileDropdown)}
                      className="relative w-[2.8rem] h-[2.8rem] flex text-sm bg-gray-800 rounded-full"
                    >
                      <span className="absolute -inset-1.5" />
                      <img
                        alt=""
                        src={getImage(user?.profile_pic)}
                        className="object-cover border-2 border-[#0f5c5b] w-full h-full rounded-full size-8"
                      />
                    </MenuButton>
                  </div>
                  <MenuItemsT
                    user={user}
                    handleLogout={handleLogout}
                    isOpen={profileDropdown}
                    setProfileDropdown={setProfileDropdown}
                  />
                </Menu>
              </>
            ) : (
              <Button
                className="ms-3"
                text="Login"
                variant="login"
                onClick={() => {
                  setLoginModalShow(true);
                }}
              />
            )}
          </div>
        </div>
      </div>

      <LoginComponent
        show={loginModalShow}
        onHide={() => setLoginModalShow(false)}
      />

      <DisclosurePanel className="lg:hidden">
        <div className="flex flex-col px-2 pt-2 pb-3 space-y-1 transition-all duration-150">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={classNames(
                activeMenu === item.href
                  ? "bg-transparent border-b-2 border-[#00504E] text-[#00504E] font-bold rounded-xl scale-[1.02]"
                  : "text-gray-600 hover:text-[#00504E] hover:scale-[1.02]",
                "rounded-xl font-medium hover:scale-110 hover:font-bold px-4 py-2 text-sm transition-all duration-200 ease-in-out transform"
              )}
              onClick={() => {
                setActiveMenu(item.href);
                localStorage.setItem("navigation", JSON.stringify(item.href));
              }}
            >
              {item.name}
            </Link>
          ))}
        </div>
      </DisclosurePanel>
      {/*  <BetaVsModel
        onHide={onHide}
        modalOpen={modalOpen}
        setPassword={setPassword}
        openSite={openSite}
        password={password}
      /> */}
    </Disclosure>
  );
}
